import React from 'react'
import Reflux from 'reflux'
import api from '../../source/api'
import Store from '../../store/store'
import Actions from '../../actions/actions'

export default class PaymentFinish extends Reflux.Component {

    constructor(props) {
        super(props)

        this.state = {
            payment_id: this.getIdFormUrl(),
            status: '',
        }
        this.store = Store
    }

    getIdFormUrl = () => {
        let hash = window.location.hash
        let id = ''
        if (hash !== '#/' && /\d/.test(hash)) {
            id = hash.replace(/^\D+/g, '')
        }
        return id
    }

    componentDidMount = () => {
        this.checkStatus();
    }

    checkStatus = () => {
        api.get('payment/detail?paymentId=')
            .then((response) => {
                Actions.userBalanceSet(response.data.balance);
                this.setState({
                    status: response.data.status,
                });

                if (response.data.status === 'Prepared') {
                    setTimeout(this.checkStatus, 3000);
                }
            })
    }

    render() {
        return (
            <section id='payment-finish'>
                <div className='container'>
                    <div className='row header'>
                        <div className='col-12 tex-center'>

                            <div className={this.state.status === 'Prepared' ? '' : 'd-none'}>
                                <h1>Az egyenlege hamarosan jóváírásra kerül.</h1>
                            </div>

                            <div className={this.state.status === 'Succeeded' ? '' : 'd-none'}>
                                <h1>Köszönjük. <br/>
                                    Az egyenlegedet jóváírtuk!
                                </h1>
                            </div>

                            <div className={this.state.status === 'Cancelled' ? '' : 'd-none'}>
                                <h1>A tranzakció meghiúsult!<br/>
                                    Próbáld újra az egyenlegfeltöltést!
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/payment/paymentfinish.js